import styled from "@emotion/styled";
import { Header } from "@silvertours/front-features";
var StyledHeader = /*#__PURE__*/ styled(Header, {
    target: "ej6paxa0"
})("background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:0 ", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";");
export { StyledHeader };
